var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('page-header',{attrs:{"mode":_vm.navBarMode}}),_c('div',{staticClass:"page-body"},[_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[_c('router-view',{key:_vm.key})],1)],1),_c('fix-tool'),(_vm.isDefaultTenant)?_c('page-footer',{ref:"pageFooter"}):_c('tenant-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }